import en from './en.json'
import it from './it.json'

export const adminLinksTranslations = {
	en,
	it
} as const
